import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {TabPane, NavItem, Nav} from 'reactstrap';
import classnames from 'classnames';
import {NavLinkStyled, HostedTagContainer, TotalCharge, TabContentStyled} from '../../styles/styled/tagsStyled';
import Tags  from "./tags";
import TagTypes from "./tag-types";
import BlessHeroes from "./bless-heroes";
import CloseButton from "../../components/buttons/close";
import  {CloseButtonContainer}   from '../privacy';

const HostedTags = (props) => {
    const {options, handleInfoStatusChanged } = props;
    const [activeTab, setActiveTab] = useState('1');
    const tagsTab = '1';
    const typesTab = '2';
    const heroesTab = '3';
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <>
            <HostedTagContainer>
                <Nav tabs>
                    <NavItem>
                        <NavLinkStyled
                            className={classnames({ active: activeTab === tagsTab })}
                            onClick={() => { toggle(tagsTab); }}>
                            Tags
                        </NavLinkStyled>
                    </NavItem>
                    <NavItem>
                        <NavLinkStyled
                            className={classnames({ active: activeTab === typesTab })}
                            onClick={() => { toggle(typesTab); }}>
                            Tag Types
                        </NavLinkStyled>
                    </NavItem>
                    <NavItem>
                        <NavLinkStyled
                            className={classnames({ active: activeTab === heroesTab })}
                            onClick={() => { toggle(heroesTab); }}>
                            #BlessOurHeroes campaigns
                        </NavLinkStyled>
                    </NavItem>
                    <NavItem />
                </Nav>
                <TabContentStyled activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Tags options={options}/>
                    </TabPane>
                    <TabPane tabId="2">
                        <TagTypes />
                    </TabPane>
                    <TabPane tabId="3">
                        <BlessHeroes/>
                    </TabPane>
                </TabContentStyled>
            </HostedTagContainer>
               <TotalCharge className="row m-0" />
                <CloseButtonContainer
                  className="buttons"  onClick={()=> handleInfoStatusChanged()}>
                <CloseButton size="2x"/>
                </CloseButtonContainer>
        </>
    );
};

HostedTags.propTypes = {
  handleInfoStatusChanged: PropTypes.func,
};

HostedTags.defaultProps = {
  handleInfoStatusChanged: () => undefined,
};

export default HostedTags;
